"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachmentFactory = exports.AttachmentEntityFactory = void 0;
const Attachment_1 = require("../sub-clients/common/model/Attachment");
const LinkEntity_1 = require("../sub-clients/common/model/LinkEntity");
class AttachmentEntityFactory {
    static sample(entity) {
        const defaults = {
            id: 'test-id',
            type: Attachment_1.AttachmentType.LESSON_PLAN,
            description: undefined,
            _links: {
                download: {
                    href: 'externallink.com',
                    templated: false,
                },
            },
        };
        return { ...defaults, ...entity };
    }
}
exports.AttachmentEntityFactory = AttachmentEntityFactory;
class AttachmentFactory {
    static sample(attachment) {
        const defaults = {
            id: 'test-id',
            type: Attachment_1.AttachmentType.LESSON_PLAN,
            linkToResource: 'some-download-href',
            description: undefined,
            links: {
                download: new LinkEntity_1.Link({ href: 'some-download-href', templated: false }),
            },
        };
        return { ...defaults, ...attachment };
    }
}
exports.AttachmentFactory = AttachmentFactory;
//# sourceMappingURL=AttachmentsFactory.js.map